import { format, isValid, parse } from 'date-fns';
import { de, enUS } from 'date-fns/locale';

import { FormatConverter } from '@disy/lib/format-converter';
import { getCurrentLocale } from '@disy/lib/locale';

export const ISO_DATE_FORMAT = 'yyyy-MM-dd';

export function formatDateWithJavaFormat(date: Date | string, javaFormat: string) {
  return format(date, convertJavaToDateFnsDateFormat(javaFormat), {
    useAdditionalDayOfYearTokens: true,
    locale: getLocale(),
  });
}

export function parseAndValidateDateWithJavaFormat(dateString: string, javaFormat: string) {
  const parsedDate = parseDateWithJavaFormat(dateString, javaFormat);
  return isValid(parsedDate) ? parsedDate : null;
}

export function parseDateWithJavaFormat(dateString: string, javaFormat: string) {
  return parse(dateString, convertJavaToDateFnsDateFormat(javaFormat), new Date(), {
    useAdditionalDayOfYearTokens: true,
    locale: getLocale(),
  });
}

function getLocale() {
  return getCurrentLocale().startsWith('en') ? enUS : de;
}

// date-fns tokens:
// https://date-fns.org/v2.22.1/docs/format
//
// Java Simple Date Format tokens:
// https://docs.oracle.com/javase/7/docs/api/java/text/SimpleDateFormat.html
const formatMapping = {
  u: 'i',
};

const formatConverter = new FormatConverter(formatMapping);

export function convertJavaToDateFnsDateFormat(javaFormat: string) {
  return formatConverter.convert(javaFormat);
}
